export default {
  title: 'How do you want to earn rewards progress?',
  primaryBtn: {
    main: 'Earn rewards automatically when I use my card',
  },
  or: 'or',
  secondaryBtn: 'Manually take photo of receipt after every purchase',
  cardAlt: 'credit-card',
}
